import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Table = styled('table')`
  width: 100%;
  table-layout: auto;
  border-spacing: 0;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdUp`
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  `}
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  thead tr th {
    ${({ theme }) => theme.typography.tiny};
    border: none;
    > * {
      display: block;
      max-width: ${({ theme }) => theme.x9spacePx}px;
      margin-right: 0;
    }
  }

  tbody tr {
    ${({ theme }) => theme.typography.baseStrong};
  }

  th,
  td {
    padding: ${({ theme }) => theme.x1spacePx / 2}px;
    text-align: left;
    border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    vertical-align: top;
    &:first-child {
      padding-left: ${({ theme }) => theme.x1spacePx}px;
    }
    &:last-child {
      padding-left: ${({ theme }) => theme.x1spacePx}px;
    }
    &:nth-child(1) {
      /* width: ${({ theme }) => theme.x6spacePx}px; */
      width: 10%;
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      width: 25%;
    }
  }
`;
